export default __webpack_public_path__ + "static/media/carousel1.435326d2.jpg";